import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-ready-dashboard',
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    templateUrl: './ready-dashboard.component.html',
    styleUrl: './ready-dashboard.component.css'
})
export class ReadyDashboardComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
}
